import React, { useState, useEffect } from 'react';
import { useSession } from '@/context/SessionContext';
import LearnerLayout from '@/components/LearnerLayout';
import { Button } from '@/components/ui/button';
import { Loader2, Star, ClipboardList } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LearnerEvaluations = () => {
  const { selectedSessionId, currentCourse } = useSession();
  const [evaluations, setEvaluations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedSessionId) { setLoading(false); return; }
    fetch(`${API}/learner/dashboard/${selectedSessionId}`, { credentials: 'include' })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d?.evaluations?.items) setEvaluations(d.evaluations.items);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [selectedSessionId]);

  const courseTitle = currentCourse?.title || 'Formation';

  return (
    <LearnerLayout>
      <div data-testid="learner-evaluations-page">
        <p className="text-sm text-slate-400 mb-6">{courseTitle} - Évaluations</p>
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-8" data-testid="evaluations-title">Évaluations</h1>

        {loading ? (
          <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-blue-600" /></div>
        ) : evaluations.length > 0 ? (
          <div className="space-y-4">
            {evaluations.map((ev, i) => (
              <div key={i} className="bg-white border border-slate-200 rounded-2xl p-6 flex items-center justify-between" data-testid={`evaluation-${i}`}>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center">
                    <ClipboardList className="h-5 w-5 text-white" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">{ev.title || 'Évaluation'}</p>
                    <p className="text-sm text-slate-500">{ev.date || ''} {ev.description || ''}</p>
                  </div>
                </div>
                <Button className="bg-blue-700 hover:bg-blue-800 text-white rounded-lg" data-testid={`start-eval-${i}`}>
                  Répondre
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-16" data-testid="no-evaluations">
            <Star className="h-12 w-12 text-slate-300 mx-auto mb-4" />
            <p className="text-slate-500">Vous n'avez aucune évaluation.</p>
          </div>
        )}
      </div>
    </LearnerLayout>
  );
};

export default LearnerEvaluations;
